module.exports = __webpack_public_path__ + "static/img/aboutus_img3@2x.58015897.png";